(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hali-ar-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hali-ar-controls')) {
    customElements.define('hali-ar-controls', class extends HTMLElement {
      connectedCallback() {
        this.onXRReady = () => this.registerModels();
        document.addEventListener('shopify_xr_initialized', this.onXRReady);
        this.frame = requestAnimationFrame(() => {
          if (window.ShopifyXR) {
            this.registerModels();
          } else if (window.Shopify?.loadFeatures) {
            window.Shopify.loadFeatures([{
              name: 'shopify-xr',
              version: '1.0',
              onLoad: (error) => {
                if (!error && this.isConnected) this.registerModels();
              }
            }]);
          }
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        document.removeEventListener('shopify_xr_initialized', this.onXRReady);
      }
      registerModels() {
        if (!window.ShopifyXR || !this.isConnected || this.registered) return;
        const source = this.querySelector('[data-hali-ar-models]');
        if (!source) return;
        try {
          const models = JSON.parse(source.textContent);
          if (!Array.isArray(models) || !models.length) return;
          window.ShopifyXR.addModels(models);
          window.ShopifyXR.setupXRElements();
          this.registered = true;
        } catch {
          this.registered = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
